// src/features/tasks/components/TaskListPage/TasksDataGrid/components/CategoryCell.jsx
import React from 'react';
import CategoryChip from '../../../../../../components/common/CategoryChip';

export default function CategoryCell({ value, row }) {
  if (!value) return null;
  return <CategoryChip name={value} color={row.category?.color_code} />;
}
